import { render, staticRenderFns } from "./orderValueGroups.vue?vue&type=template&id=395558f0&"
import script from "./orderValueGroups.vue?vue&type=script&lang=js&"
export * from "./orderValueGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports